
import {filter} from 'rxjs/operators';
import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';


@Component({
    selector: 'app-nav-new-tab',
    templateUrl: './nav-new-tab.component.html',
    styleUrls: ['./nav-new-tab.component.scss']
})
export class NavNewTabComponent {
    constructor(router: Router) {
        router.events.pipe(
            filter(e => e instanceof NavigationEnd))
            .subscribe(e => {
                this.currentUrl = decodeURI((<NavigationEnd>e).url);
            });
    }

    public currentUrl?: string;
}
